import Text from "atoms/Text";
import PropTypes from "prop-types"

function Footer({ className = '' }) {
    return (
        <div className={`footer mt-8 flex gap-3 flex-col  bg-black px-6 py-3 sticky top-full ${className}`}>
            <Text variant='bodySemibold' className='text-white'>Deloitte | sPInE - Resource Management <span className='text-gray-400 block md:inline'> (less of staffing, more of People Insights n Experience)</span></Text>
            <Text variant='label' className='text-gray-400'>&copy; 2024 For information, contact Deloitte Global</Text>
        </div>
    )
};

Footer.propTypes = {
    className: PropTypes.string
};

export default Footer